import { Object3D, InstancedMesh, Clock, MeshBasicMaterial } from "three"
import { WoozyRefractionInstancedMaterial } from './WoozyRefractionInstancedMaterial'
import { loadGLTF } from '../../Reusable/loadGLTF'

export class WoozyDiamonds {
  constructor ({ renderer, onResize, onLoop, scene, camera, getScreen, cubeCam }) {
    this.renderer = renderer
    this.onResize = onResize
    this.onLoop = onLoop
    this.camera = camera
    this.getScreen = getScreen
    this.o3d = new Object3D()
    this.scene = scene
    this.cubeCam = cubeCam

    this.refractionMaterial = new WoozyRefractionInstancedMaterial()

    this.clock = new Clock()

    this.dummy = new Object3D()
    this.viewport = {
      width: 25,
      height: 25,
      depth: 30
    }

    this.o3d.rotateX(Math.PI * 0.5)

    this.diamonds = new Array(30).fill().map((_, i) => ({
      position: [i < 5 ? 0 : this.viewport.width / 2 - Math.random() * this.viewport.width, this.viewport.depth - Math.random() * this.viewport.depth, i < 5 ? 26 : 10 - Math.random() * 20],
      factor: 0.1 + 0.5 * Math.random(),
      direction: Math.random() < 0.5 ? -1 : 1,
      rotation: [Math.sin(Math.random()) * Math.PI, Math.sin(Math.random()) * Math.PI, Math.cos(Math.random()) * Math.PI]
    }))

    this.diamondURL = require('file-loader!./glb/diamond.glb')
    loadGLTF(this.diamondURL)
      .then((item) => {
        if (item && item.scene && item.scene.children && item.scene.children[0] && item.scene.children[0].geometry) {
          let geo = item.scene.children[0].geometry
          this.model = new InstancedMesh(geo, new MeshBasicMaterial({ color: 0xfababa }), this.diamonds.length)
          this.o3d.add(this.model)
        }
      })

    this.refractionMaterial.tCube = this.cubeCam.out.envMap
    // this.refractionMaterial.blending = MultiplyBlending
    this.cubeCam.add(this.o3d)

    let looper = () => {
      if (!this.model || !this.model.geometry) {
        return
      }

      // Update instanced diamonds
      this.diamonds.forEach((data, i) => {
        const t = this.clock.getElapsedTime()
        data.position[1] -= (data.factor / 5) * data.direction
        if (data.direction === 1 ? data.position[1] < -50 : data.position[1] > 50)
          data.position = [i < 5 ? 0 : this.viewport.width / 2 - Math.random() * this.viewport.width, 50 * data.direction, data.position[2]]
        const { position, rotation, factor } = data
        this.dummy.position.set(position[0], position[1], position[2])
        this.dummy.rotation.set(rotation[0] + t * factor, rotation[1] + t * factor, rotation[2] + t * factor)
        this.dummy.scale.set(1 + factor, 1 + factor, 1 + factor)
        this.dummy.updateMatrix()
        this.model.setMatrixAt(i, this.dummy.matrix)
      })
      this.model.instanceMatrix.needsUpdate = true

      this.model.material = this.refractionMaterial
    }

    this.onLoop(() => {
      looper()
    })
  }
}